/* eslint-disable */
import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    content: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
    },
    row: {
      display: "flex",
      height: theme.spacing(4),
      justifyContent: "space-between",
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      background: "rgba(0, 0, 0, 0.03)",
      "&:nth-child(2n)": {
        background: "none",
      },
    },
    cell: {
      color: "#333333",
      opacity: 0.8,
      fontSize: "14px",
      lineHeight: "17px",
      height: "inherit",
      display: "flex",
      alignItems: "center",
      flex: 1,
      justifyContent: "flex-end",
      "&:nth-child(1)": {
        flex: 4,
        justifyContent: "flex-start",
      },
    },
  });

export const useStyles = makeStyles(styles);
